import {LeftArrow, RightArrow} from "../svg/Arrows";
import classes from "../../components/pagination/pagination.module.css";
import ReactPaginate from "react-paginate";
import React from "react";

const PaginationComponent = ({countElements, size, handlePageClick, page}) => {
    return <div>
        <ReactPaginate
            previousLabel={<LeftArrow/>}
            nextLabel={<RightArrow/>}
            breakLabel={'...'}
            initialPage={page}
            breakClassName={classes.breakMe}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            pageCount={Math.ceil(countElements / size)}
            onPageChange={handlePageClick}
            containerClassName={classes.pagination}
            activeClassName={classes.active}
            forcePage={page}
        />
    </div>
}

export default PaginationComponent;